import { useEffect, useState } from 'react';
import { IMAGE_FALLBACK } from '../data/destinationImages';

function SafeImage({
  src,
  alt,
  className,
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
}) {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  const handleError = () => {
    if (imgSrc !== IMAGE_FALLBACK) {
      setImgSrc(IMAGE_FALLBACK);
    }
  };

  return (
    <img
      className={className}
      src={imgSrc}
      alt={alt}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding={decoding}
      onError={handleError}
    />
  );
}

export default SafeImage;
